import { z } from 'zod';
export const partnerCompanyTypeSchema = z.enum(['AG', 'GmbH', 'Einzelfirma', 'KlG']);
export const PartnerCompanyType = partnerCompanyTypeSchema.enum;
export const isSoleProprietorship = (companyType) => companyType === PartnerCompanyType.Einzelfirma;
